
<template>
  <v-container :class="`${arabic ? 'arFont' : 'enFont'} mt-12 pt-8`" style="background:#fafafa;">
    <v-row style="background:#fafafa;">
      <v-col cols="12" class="pa-0">
        <v-row class="py-1 px-5">
          <v-col cols="12" class="text-center">
            <v-row justify="center">

              <v-col cols="12" sm="10" md="8" class="text-center"> <!-- Adjusted for better responsive behavior -->
                <v-alert v-if="alert.show && alert.type === 'success'"  color="green"  dense   prominent  type="success">
                  {{ arabic ? 'تمت العملية بنجاح' : 'Operation successful' }}
                </v-alert>

                <!-- Vuetify Alert for Cancellation -->
                <v-alert v-if="alert.show && alert.type === 'error'" color="red" dense  prominent type="error" >
                  {{ arabic ? 'لم تتم العملية بنجاح. يرجى المحاولة مرة أخرى لاحقًا' : 'Operation unsuccessful. Please try again later.' }}
                </v-alert>
              </v-col>
              </v-row>
              <v-row class="justify-center">
                  <v-col cols="6" md="4" :class="`${arabic ? 'arFont' : 'enFont'}`">
                        <v-btn color="success" block @click="videoDialog = true">{{i18n['intro_video']}}</v-btn>
                        <VideoDialog @close="closeVideoDialog" :dialog="videoDialog">
                            <iframe width="100%" height="540"  src="https://www.youtube.com/embed/FedzfPNZEug?si=35Dj6OUhmA1fFU7T" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>  
                        </VideoDialog>
                </v-col>
              </v-row>
           
            <h1>{{ arabic ? 'خطط الاشتراكات' : 'Subscription Plans' }}</h1>
            <h4>{{ arabic ? 'اختر الخطة الأفضل التي تناسب احتياجاتك .' : 'Choose the plan that better fits your needs.' }}</h4>

              <v-btn v-if="is_subscription==true && subscription_is_free==false"
                 color="primary" class="mt-3 mb-5" style="width: 200px;" @click="redirectToBilling">
                 {{ arabic ? 'الفواتير' : 'Billing' }}
              </v-btn>
            <v-container class="pricing mt-12">
              <v-row :class="`${arabic ? 'arFont' : 'enFont'}`">
                <!-- Plan rendered dynamically -->
                <v-col cols="12" md="4" v-for="plan in plans" :key="plan.id">
                  

                  <v-card :class="{ 'plan': true, 'popular': plan.is_popular }">
                    <span v-if="plan.is_popular"> {{ arabic ? 'الاكثر طالبا ': 'Most Popular' }}</span>
                    <v-alert
                    color="red" text type="error" v-if="plan.limitation_mark">
                  
                  {{arabic ? 'هذه الخطة اصغر من استهلاكك' : 'This plan is smaller than your consumption.' }}

                  </v-alert>
                    <h2>{{ arabic ? plan.title_ar : plan.title }}</h2>
                    <div class="price">$ {{ plan.price }} / {{ arabic ? 'شهر' : 'Month' }}</div>



                    <p>{{ arabic ? plan.description_ar : plan.description }}</p>
                 
                    <ul class="features" v-if="arabic">
                      <li>
                          <v-icon color="success">
                          mdi-check-circle
                          </v-icon>
                        {{ i18n['form_views'] }}: {{plan.form_views }}
                      </li>
                      <li>
                          <v-icon color="success">
                          mdi-check-circle
                          </v-icon>
                          {{ i18n['form_submission'] }}: {{plan.form_submissions }}
                      </li>
                      <li>
                          <v-icon color="success">
                          mdi-check-circle
                          </v-icon>
                        {{ i18n['form_number'] }}: {{plan.form_number }}
                      </li>
                      </ul>

                      <ul class="features" v-if="(!arabic)">
                      <li>
                          <v-icon color="success">
                          mdi-check-circle
                          </v-icon>
                        {{ i18n['form_views'] }}: {{plan.form_views }}
                      </li>
                      <li>
                          <v-icon color="success">
                          mdi-check-circle
                          </v-icon>
                          {{ i18n['form_submission'] }}: {{plan.form_submissions }}
                      </li>
                      <li>
                          <v-icon color="success">
                          mdi-check-circle
                          </v-icon>
                        {{ i18n['form_number'] }}: {{plan.form_number }}
                      </li>
                      </ul>

                    <!-- For non-Arabic features -->
                      <ul  class="features" v-if="!arabic">
                      <li v-for="feature in parsedFeatures(plan)" :key="feature.feature">
                          <v-icon :color="feature.available ? 'success' : 'error'">
                          {{ feature.available ? 'mdi-check-circle' : 'mdi-close-circle' }}
                          </v-icon>
                          {{ feature.feature }}
                      </li>
                      </ul>

                      <!-- For Arabic features -->
                      <ul style="text-align: right;" class="features" v-if="arabic">
                      <li v-for="feature in parsedFeatures(plan)" :key="feature.feature_ar">
                          <v-icon :color="feature.available_ar ? 'success' : 'error'">
                          {{ feature.available_ar ? 'mdi-check-circle' : 'mdi-close-circle' }}
                          </v-icon>
                          {{ feature.feature_ar }}
                      </li>
                      </ul>
                      <template>
                        <div v-if="!plan.is_free">
                            <v-btn 
                                color="primary" 
                                class="mt-3" 
                                style="width: 300px;" 
                                :disabled="plan.is_subscribed || !!plan.limitation_mark"
                                @click="choosePlan(plan.price_id, plan.plan_slug)"> 
                                {{ plan.is_subscribed ? arabic ? 'هذه الخطة المختارة' : 'This plan choosed ':arabic ? 'اختر خطة' : 'Choose Plan' }}
                            </v-btn>
                        </div>

                        <div v-else>
                          <div v-if="is_subscription==true && subscription_is_free==false">
                            <v-btn 
                                color="primary" 
                                class="mt-3" 
                                style="width: 300px;" 
                                :disabled="plan.is_subscribed || !!plan.limitation_mark"
                                 @click="redirectToBilling"> 
                                {{ plan.is_subscribed ? arabic ? 'هذه الخطة المختارة' : 'This plan choosed ':arabic ? 'اختر خطة' : 'Choose Plan' }}
                            </v-btn>
                          </div>
                        <div v-else>

                          <v-btn 
                                color="primary" 
                                class="mt-3" 
                                style="width: 300px;" 
                                :disabled="plan.is_subscribed || !!plan.limitation_mark"
                                @click="choosePlanFree(plan.plan_slug)"> 
                                {{ plan.is_subscribed ? arabic ? 'هذه الخطة المختارة' : 'This plan choosed ':arabic ? 'اختر خطة' : 'Choose Plan' }}
                            </v-btn>
                        </div>
                            
                        </div>
                          
                        </template>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios';
import VideoDialog from '@/components/VideoDialog.vue';

export default {
components: {
      VideoDialog
  },
data() {
  return {
    videoDialog:false,

    is_subscription:false,
    subscription_is_free:false,
    plans: [],
    alert: {
      show: false,
      type: ''
    },

  };
},

computed: {
  language() {
    return this.$store.state.language;
  },
  arabic() {
    return this.language === "ar";
  },
  i18n() {
          return this.$store.state.i18n[this.$store.state.language];
      },
},

methods: {
  fetchPlans() {
const resource = '/plans/active';
const payload = {
  resource: resource
};

this.$store.dispatch('getResource', payload)
  .then(response => {
    this.plans = response.map(plan => ({
      ...plan,
      features: plan.features,
      features_ar: plan.features_ar
    }));
  })
  .catch(error => {
    console.error('There was an error fetching the plans:', error);
  });
},


is_subscriptions() {
const resource = '/is_subscription';
const payload = {
  resource: resource
};
this.$store.dispatch('getResource', payload)
  .then(response => {
    this.is_subscription = response.subscription_active;
    console.log(response.subscription_active);
  })
  .catch(error => {
    console.error('There was an error fetching the subscription status:', error);
  });
},



is_subscription_free() {
const resource = '/is_free_plan';

const payload = {
  resource: resource
};
this.$store.dispatch('getResource', payload)
  .then(response => {
    this.subscription_is_free = response.subscription_is_free;
    console.log(response.subscription_is_free);
  })
  .catch(error => {
    console.error('There was an error fetching the subscription status:', error);
  });
},

choosePlan(priceId, planSlug) {
const resource = `/webhook/checkout/${priceId}/${planSlug}`;

const payload = {
  resource: resource
};

this.$store.dispatch('getResource', payload)
  .then(response => {
    window.location.href = response.url;
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Failed to fetch plan. Please connect with the Admin system.');
  });
},

choosePlanFree(planSlug) {
const resource = `/plan-free-subscripe/${planSlug}`;

const payload = {
  resource: resource
};

this.$store.dispatch('postResource', payload)
  .then(response => {
    window.location.href = response.url;
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Failed to subscribe to the free plan.');
  });
}
,

async redirectToBilling() {
try {
  const resource = '/billing_portal';

  const payload = {
    resource: resource
  };

  const response = await this.$store.dispatch('getResource', payload);
  console.log(response)
  window.location.href = response; 
} catch (error) {
  console.error('API call failed:', error);
}
},
closeVideoDialog(){
    this.videoDialog = false
  },
  parsedFeatures(plan) {
  try {
    if (this.arabic) {
      return JSON.parse(plan.features_ar);
    } else {
      return JSON.parse(plan.features);
    }
  } catch (error) {
    console.error('Error parsing features:', error);
    return [];
  }
}
},

mounted() {
  this.fetchPlans();
  this.is_subscriptions();
  this.is_subscription_free();
  const queryParams = new URLSearchParams(window.location.search);
  const type = queryParams.get('type');
  if (type === 'success') {
    this.alert = { show: true, type: 'success' };
  } else if (type === 'cancel') {
    this.alert = { show: true, type: 'error' };
  }

}
}
</script>

<style scoped>
h1,h4 {
  text-align: center;
  margin-top: 2rem;
}



p {
  text-align: center;
  margin-bottom: 4rem;
}

.pricing {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.plan {
  background-color: #fff;
  padding: 2.5rem;
  margin: 12px;
  border-radius: 5px;
  text-align: center;
  transition: 0.3s;
  cursor: pointer;
}

.plan h2 {
  font-size: 22px;
  margin-bottom: 12px;
}

.plan .price {
  margin-bottom: 1rem;
  font-size: 30px;
}

.plan ul.features {
  list-style-type: none;
  padding: 0;
  text-align: left;
}

.plan ul.features li {
  margin: 8px;
  display: flex;
  align-items: center;
}

.plan button {
  border: none;
  width: 100%;
  padding: 12px 35px;
  margin-top: 1rem;
  background-color: #6ab04c;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.plan.popular {
  border: 2px solid #6ab04c;
  position: relative;
  transform: scale(1.08);
}

.plan.popular span {
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #6ab04c;
  color: #fff;
  padding: 4px 20px;
  font-size: 18px;
  border-radius: 5px;
}

.plan:hover {
  box-shadow: 5px 7px 67px -28px rgba(0, 0, 0, 0.37);
}
</style>
